import { Component } from '@angular/core';
import { CatalogItemsDefaultComponent } from './catalog-items-default.component';
import { CartService } from './cart/cart.service';
import { CompareService } from './compare/compare.service';
import { ConsultService } from './consult.service';
import {CityService} from './city.service';

@Component({
  selector: 'catalog-items',
  templateUrl: './catalog/catalog-section-items/catalog-items.component.html',
  styleUrls: ['./catalog/catalog-section-items/catalog-items.component.less']
})
export class CatalogItemsComponent extends CatalogItemsDefaultComponent {

  constructor(
    protected cartService: CartService,
    protected compareService: CompareService,
    protected consult: ConsultService,
    public cityService: CityService
  ) {
    super(cartService, compareService, consult);
  }

}
